import React, { useCallback, useState } from 'react';
import { Box, Flex, Image } from 'rebass';
import PropTypes from 'prop-types';
import store from 'store';

import SafariVideoNode from './SafariVideoNode';
import BufferingOverlay from 'app/modal/BufferingOverlay';
import useTimerTo from './Trimmer/hooks/timer';
import PreviewControls from 'stories/tell-a-story/PreviewControls';

const ClipPreview = ({ id, clipDetails, isForEdit }) => {
  const [shouldPlay, setShouldPlay] = useState(false);
  const [isBuffering, setIsBuffering] = useState(false);
  const [{ seconds, endSeconds, isRunning }, dispatch] = useTimerTo(clipDetails ? (clipDetails?.['trim-end'] - clipDetails?.['trim-start']) : 0);

  const handlePlayClick = useCallback(() => {
    setShouldPlay(true);
  }, [setShouldPlay]);

  const handleProgress = useCallback(
    (value) => {
      if (value === 0 || value) dispatch({ type: 'setSeconds', seconds: value });
    },
    [dispatch]
  );

  const handlePauseClick = useCallback(() => {
    setShouldPlay(false);
  }, [setShouldPlay]);

  const handleSliderChange = useCallback(
    (value) => {
      dispatch({ type: 'stop' });
      dispatch({ type: 'setSeconds', seconds: value });
      store.set('currentSeconds', value);
      setShouldPlay(false);
    },
    [dispatch, isRunning]
  );

  return (
    <Box pb={2}>
      <BufferingOverlay isBuffering={isBuffering}>

        <Box width="300px" minHeight="300px" sx={{ borderRadius: '11.559px', overflow: 'hidden' }}>
          <SafariVideoNode
            width={"300px"} minHeight="300px"
            nodeInRange
            shouldPlay={shouldPlay}
            clipDetail={clipDetails}
            currentTime={seconds}
            startAt={clipDetails?.['trim-start']}
            endAt={endSeconds}
            onProgress={handleProgress}
            onPlay={handlePlayClick}
            onPause={handlePauseClick}
            id={id}
            isForEdit={isForEdit}
            setBuffering={(val) => setIsBuffering(val)}
          />
        </Box>
      </BufferingOverlay >
      <PreviewControls
        isPlaying={shouldPlay}
        onPlayClick={handlePlayClick}
        onPauseClick={handlePauseClick}
        currentSeconds={seconds}
        endSeconds={endSeconds}
        onSliderChange={handleSliderChange}
        isBuffering={isBuffering}
        clip={clipDetails}
        individualClip={true}
      />
    </Box >
  )
};

ClipPreview.propTypes = {

};

export default ClipPreview;